export const colors = {
  red: "#e53935",
  orange: "orange",
  green: "#8dc540",
  primaryGray: "#b6b6b6",
  secondaryGray: "#736e6e",
  white: "#ffffff",
  black: "#000000",
};
